import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../context/StoreContext';
import { subscriptionsAPI } from '../api';

export default function SubscriptionBanner() {
  const { selectedStore } = useStore();
  const navigate = useNavigate();
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    if (!selectedStore) return;

    const checkSubscription = async () => {
      try {
        const res = await subscriptionsAPI.getStoreSubscription(selectedStore.id);
        const sub = res.data?.subscription;
        if (!sub) return;

        if (sub.status === 'trialing' && sub.trial_ends_at) {
          const daysLeft = sub.trial_days_remaining != null
            ? sub.trial_days_remaining
            : Math.ceil((new Date(sub.trial_ends_at) - new Date()) / (1000 * 60 * 60 * 24));
          if (daysLeft <= 7 && daysLeft > 0) {
            setBanner({
              type: 'warning',
              message: `Your free trial ends in ${daysLeft} day${daysLeft !== 1 ? 's' : ''}. Upgrade now to keep your features.`,
              action: 'Upgrade',
            });
          } else if (daysLeft <= 0) {
            setBanner({
              type: 'error',
              message: 'Your free trial has expired. Upgrade to continue using all features.',
              action: 'Upgrade Now',
            });
          }
        } else if (sub.status === 'past_due') {
          setBanner({
            type: 'error',
            message: 'Payment failed. Please update your payment method to avoid service interruption.',
            action: 'Fix Payment',
          });
        } else if (sub.status === 'expired') {
          setBanner({
            type: 'error',
            message: 'Your subscription has expired. Reactivate to continue using the platform.',
            action: 'Reactivate',
          });
        } else if (sub.status === 'canceled') {
          setBanner({
            type: 'info',
            message: 'Your subscription has been canceled. You can reactivate anytime.',
            action: 'Reactivate',
          });
        } else {
          setBanner(null);
        }
      } catch {
        // Silently ignore - banner is non-critical
      }
    };

    checkSubscription();
  }, [selectedStore]);

  if (!banner) return null;

  const bgColor = banner.type === 'error' ? '#FEF2F2' : banner.type === 'warning' ? '#FFFBEB' : '#EFF6FF';
  const borderColor = banner.type === 'error' ? '#EF4444' : banner.type === 'warning' ? '#F59E0B' : '#3B82F6';
  const textColor = banner.type === 'error' ? '#991B1B' : banner.type === 'warning' ? '#92400E' : '#1E40AF';

  return (
    <div
      className="subscription-banner"
      style={{
        background: bgColor,
        borderLeft: `4px solid ${borderColor}`,
        color: textColor,
      }}
    >
      <span className="subscription-banner-text">{banner.message}</span>
      <button
        className="subscription-banner-btn"
        style={{ color: borderColor, borderColor }}
        onClick={() => navigate(banner.type === 'error' && banner.action === 'Fix Payment' ? '/billing' : '/pricing')}
      >
        {banner.action}
      </button>
      <button
        className="subscription-banner-close"
        onClick={() => setBanner(null)}
        aria-label="Dismiss"
      >
        &times;
      </button>
    </div>
  );
}
